import React from "react";
import { cn } from "../../lib/cn";

const variants = {
  default: "bg-neutral-100 text-neutral-600 border border-neutral-200",
  primary: "bg-primary-50 text-primary-600 border border-primary-100",
  secondary: "bg-secondary-50 text-secondary-700 border border-secondary-100",
  success: "bg-emerald-50 text-emerald-700 border border-emerald-100",
  warning: "bg-amber-50 text-amber-700 border border-amber-100",
  danger: "bg-rose-50 text-rose-700 border border-rose-100",
};

export function Badge({ className, variant = "default", children, ...props }) {
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1 rounded-full px-3 py-1 text-xs font-medium",
        variants[variant] || variants.default,
        className
      )}
      {...props}
    >
      {children}
    </span>
  );
}


